import { FacettenOptionInfo } from '../services/facetten/facetten-option-info';

/**
 * Repräsentation der Barrierefreiheit aus dem Backend
 */
export enum Barrierefreiheit {
  RAEUMLICHE_BARRIEREFREIHEIT = 'RAEUMLICHE_BARRIEREFREIHEIT',
  DIGITALE_BARRIEREFREIHEIT = 'DIGITALE_BARRIEREFREIHEIT',
  RAEUMLICHE_UND_DIGITALE_BARRIEREFREIHEIT = 'RAEUMLICHE_UND_DIGITALE_BARRIEREFREIHEIT'
}

/**
 * backendId ist die ID die zwischen unseren UI und unseren Backend gesendet wird.
 */
export type FacettenOptionInfoBarrierefreiheit = FacettenOptionInfo & {
  backendId: Barrierefreiheit;
};

export const barrierefreiheitOptions: FacettenOptionInfoBarrierefreiheit[] = [
  {
    id: 'RB',
    backendId: Barrierefreiheit.RAEUMLICHE_BARRIEREFREIHEIT,
    bezeichnung: 'Räumliche Barrierefreiheit'
  },
  {
    id: 'DB',
    backendId: Barrierefreiheit.DIGITALE_BARRIEREFREIHEIT,
    bezeichnung: 'Digitale Barrierefreiheit'
  },
  {
    id: 'RDB',
    backendId: Barrierefreiheit.RAEUMLICHE_UND_DIGITALE_BARRIEREFREIHEIT,
    bezeichnung: 'Räumliche und digitale Barrierefreiheit'
  }
];
